import script from "./CourtesyRepullDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./CourtesyRepullDetails.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/loans/form.css?vue&type=style&index=0&id=67050508&scoped=true&lang=css&external"
import "@/assets/css/grid.css?vue&type=style&index=1&id=67050508&scoped=true&lang=css&external"
import "./CourtesyRepullDetails.vue?vue&type=style&index=2&id=67050508&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67050508"]])

export default __exports__